import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

import { Page, PageProps } from "./interfaces/Page";

interface Props extends PageProps {
  name: string;
}

const MenuItem = ({ pages = [], name }: Props) => {
  return (
    <Popover className="relative">
      <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
        <span>{name}</span>
        <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
      </Popover.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4">
          <div className="max-w-md flex-auto overflow-hidden rounded-[--border-radius] bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
            <div
              className={`py-6 pl-5  ${pages?.[0].sublinks?.length && "flex"}`}
            >
              {pages?.map((item: Page) =>
                item.sublinks?.length ? (
                  <div key={item.path} className="pr-16 flex-col">
                    <div>
                      <p className="text-lg font-bold text-[--primary800] p-2">
                        {item.name}
                      </p>
                      {item.sublinks?.map((page) => (
                        <Item {...page} key={page.id}></Item>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div key={item.id} className="pr-16">
                    <Item {...item} />
                  </div>
                )
              )}
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

const Item = ({ name, path }: Page) => {
  return (
    <div className="p-2  ">
      <a
        href={path}
        className="font-normal text-base text-gray-900 w-full hover:text-[--primary400] "
      >
        {name}
      </a>
    </div>
  );
};

export default MenuItem;
